import React, { useState, useEffect } from 'react';
import { Grid, Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import { People as PeopleIcon, CheckCircle as CheckCircleIcon, HourglassTop as HourglassIcon, Public as PublicIcon } from '@mui/icons-material';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';

// Un componente reutilizable para cada tarjeta de métrica
const MetricCard = ({ title, value, icon, color }) => (
    <Card sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
        <Box sx={{ mr: 2, color: color || 'text.secondary' }}>
            {icon}
        </Box>
        <Box>
            <Typography variant="h5" component="div">{value}</Typography>
            <Typography color="text.secondary">{title}</Typography>
        </Box>
    </Card>
);

const Dashboard = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [metrics, setMetrics] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiEndpoint = Amplify.getConfig().API.REST.dnaAdminApi.endpoint;

    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const session = await fetchAuthSession();
                const idToken = session.tokens?.idToken?.toString();
                if (!idToken) throw new Error('Token no encontrado');

                const response = await fetch(`${apiEndpoint}/admin/dashboard`, {
                    headers: { 'Authorization': idToken }
                });
                if (!response.ok) throw new Error('Error de red');

                const responseJson = await response.json();
                if (responseJson.success) {
                    setMetrics(responseJson.data);
                } else {
                    throw new Error(responseJson.msg);
                }
            } catch (err) {
                setError('No se pudieron cargar las métricas.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        if (user) {
            fetchMetrics();
        }
    }, [user, apiEndpoint]);

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;
    if (!metrics) return null;

    return (
        <Box>
            <Typography variant="h4" gutterBottom>Dashboard Principal</Typography>
            <Grid container spacing={3}>
                {/* Fila de Métricas Clave */}
                <Grid item xs={12} sm={6} md={3}>
                    <MetricCard title="Total de Usuarios" value={metrics.totalUsers} icon={<PeopleIcon fontSize="large" />} color="primary.main" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <MetricCard title="Suscripciones Activas" value={metrics.activeSubscriptions} icon={<CheckCircleIcon fontSize="large" />} color="success.main" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <MetricCard title="Usuarios en Prueba" value={metrics.trialSubscriptions} icon={<HourglassIcon fontSize="large" />} color="warning.main" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <MetricCard title="Países Soportados" value={metrics.supportedCountries} icon={<PublicIcon fontSize="large" />} color="info.main" />
                </Grid>

                {/* Sección para Futuras APIs */}
                <Grid item xs={12} sm={6}>
                    <MetricCard title="Enlaces Acortados" value="-" icon={<div style={{fontSize: 28}}>🔗</div>} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <MetricCard title="Contactos Validados" value="-" icon={<div style={{fontSize: 28}}>📧</div>} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;